<template>
  <div class="template">
    <div class="search">
      <div>
        <Input
          v-model="search.search"
          placeholder="关键字"
          style="width: 310px; margin-right: 10px"
          icon="ios-search"
        ></Input>
        <Button style="width: 90px" type="primary" icon="ios-search" @click="searchFn">搜索</Button>
      </div>
      <div>
        <Button type="primary" @click="diyDom.showField = true" style="width: 90px; margin-right: 10px">
          字段设置
        </Button>
        <Button type="primary" style="width: 90px" @click="diyDom.showLicense = true">添加</Button>
      </div>
    </div>
    <div class="filter">
      <div class="filter-item">
        <span class="title">状态</span>
        <Select v-model="search.status" placeholder="请选择状态" style="width: 200px">
          <Option label="全部" value=""></Option>
          <Option label="有效" value="1"></Option>
          <Option label="无效" value="0"></Option>
        </Select>
      </div>
      <div class="filter-item">
        <Button type="primary" style="width: 90px" @click="searchFn">搜索</Button>
        <Button style="margin-left: 10px; width: 90px" @click="clearFn">清空</Button>
      </div>
    </div>
    <div class="table">
      <Table border :columns="diyData.columns" :data="apiData.tableList">
        <template slot="footer">
          <Page
            :total="apiData.total"
            show-total
            :page-size="apiData.per_page"
            :current="search.page"
            class-name="footer-page"
            @on-change="pageChange"
          ></Page>
        </template>
      </Table>
    </div>
    <!-- 创建证书 -->
    <add-license
      v-model="diyDom.showLicense"
      :isEdit="diyDom.isEdit"
      :id="diyData.id"
      :default-fields="apiData.defaultFields"
      @on-success="getTableList"
    ></add-license>

    <!-- 字段管理 -->
    <licenseField v-model="diyDom.showField"></licenseField>
  </div>
</template>

<script>
  import addLicense from './add-license.vue'
  import licenseField from './license-field/license-field.vue'
  import * as apiCertificates from '@/api/certificates'
  export default {
    components: {
      addLicense,
      licenseField,
    },
    name: 'tableList',
    data() {
      return {
        query: {},
        search: {
          search: '',
          status: '',
          page: 1,
        },
        diyDom: {
          showLicense: false,
          showField: false,
          isEdit: false,
        },
        diyData: {
          id: '',
          columns: [
            {
              title: 'ID',
              render: (h, params) => {
                return h('div', params.index + 1)
              },
            },
            {
              title: '证书名称',
              key: 'title',
            },
            {
              title: '状态',
              key: 'status_label',
            },
            {
              title: '创建时间',
              key: 'created_at',
            },
            {
              title: '操作',
              fixed: 'right',
              render: (h, params) => {
                return h('div', [
                  h(
                    'a',
                    {
                      style: {
                        marginRight: '10px',
                        color: '#2D8cF0',
                      },
                      on: {
                        click: () => {
                          this.diyDom.isEdit = true
                          this.diyData.id = params.row.id
                          this.diyDom.showLicense = true
                        },
                      },
                    },
                    '编辑'
                  ),
                  h(
                    'a',
                    {
                      style: {
                        marginRight: '10px',
                        color: '#2D8cF0',
                      },
                      on: {
                        click: () => {
                         this.$router.push({
                          name:'license-template',
                          query:{
                            id:params.row.id
                          }
                         })
                        },
                      },
                    },
                    '证书模板'
                  ),
                  h(
                    'a',
                    {
                      style: {
                        marginRight: '10px',
                        color: 'red',
                      },
                      on: {
                        click: () => {
                          this.$Modal.confirm({
                            title: '提示',
                            content: '请确认是否删除当前数据？',
                            onOk: () => {
                              apiCertificates.apiCertificatesDetele(params.row.id).then(res => {
                                this.$Message.success('已删除')
                                this.getTableList()
                              })
                            },
                          })
                        },
                      },
                    },
                    '删除'
                  ),
                ])
              },
            },
          ],
        },
        apiData: {
          total: 0,
          per_page: 0,
          tableList: [],
          defaultFields: [], // 证书系统字段
        },
      }
    },
    methods: {
      // 获取表格数据
      getTableList() {
        this.$store.commit('setSpinShow', true)
        apiCertificates
          .apiCertificatesList({ ...this.search })
          .then(res => {
            const { data, meta } = res
            this.apiData.tableList = data
            this.apiData.per_page = meta.pagination.per_page
            this.apiData.total = meta.pagination.total
            this.apiData.defaultFields = meta.default_fields
          })
          .finally(() => this.$store.commit('setSpinShow', false))
      },
      // 分页
      pageChange(e) {
        this.search.page = e
        this.getTableList()
      },
      // 搜索
      searchFn() {
        this.search.page = 1
        this.getTableList()
      },
      // 清空
      clearFn() {
        this.search = {
          search: '',
          status: '',
          page: 1,
        }
        this.getTableList()
      },
    },
    watch:{
      "diyDom.showLicense"(val) {
        if(!val) {
          this.diyDom.isEdit = false
        }
      }
    },
    mounted() {
      this.getTableList()
    },
  }
</script>

<style scoped lang="less">
  .template {
    .search {
      display: flex;
      justify-content: space-between;
    }
    .table {
      margin-top: 10px;
    }
    .filter {
      margin: 10px 0;
      display: flex;
      justify-content: left;
      align-items: center;
      padding: 6px 0 20px 0;
      flex-wrap: wrap;
      border: 1px solid rgba(237, 237, 237, 1);

      .filter-item {
        margin: 14px 0 0 20px;

        .title {
          margin-right: 10px;
          font-size: 12px;
          font-weight: 400;
          color: rgba(74, 74, 74, 1);
          line-height: 17px;
        }
      }
    }
  }
</style>
